<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  created() {},
  sockets: {
    connect() {
      // Fired when the socket connects.
      console.log('connected')
    },

    disconnect() {
      console.log('dis connected')
    },
    extension(data) {
      console.log(data)
      this.$toasted.show(`extension ${data.extension} is : ${data.status}`, {
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    }
  }
}
</script>

<style lang="scss">
@import 'sass/main';

body {
  height: 100%;
  #app {
    height: 100%;
  }
}
</style>
